import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const reproduction: ImportTypeConfig = {
  type: 'reproduction',
}
